(function (ws) {
    'use strict';
    ws.views.ManualcompRMAForm = ws.views.form.extend({
        events: {
            'click .rma-addRow': 'addNewRow',
            'click .rma-deleteRow': 'deleteRow',
            'click [type="submit"]': 'checkRequired',
            'focusout .error': 'checkMandatory',
            'keyup .number': 'quantityValidation',
            'keydown .number': 'quantityValidation',
            'click .rma-serialNimber-button': 'addSerialNumberField',
            'focusout .returnQuantities': 'addSerialNumberField'
        },
        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'rma_activity',
        GTM_EVENT_ACTION: 'request rma step 1',
        /**
         * Initialize function
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);
            this.$additionalInfoField = this.$('textarea[name=additionalInfo]');
            this.$additionalInfoError = this.$('.rma-additional-error');
            this.$serialInfoError = this.$('.rma-serialInfo-error');
            this.$selectedCheckbox = this.$('.selectedCheckbox');
            this.$returnQuantities = this.$('.returnQuantities');
            this.$rowTemplate = _.template(this.$('#comp-table-newRow').html());
            this.$returnableRowTemplate = _.template(this.$('#comp-returnable-quantity-row').html());
            this.errorMsg = this.$('.require-error-message');
            this.$submitButton = this.$('.rma-submit-button');
            this.$index = 1;
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.checkReturnQuantities();
            this.checkOtherDropdown();
        },

        addNewRow: function (ev) {
            ev.preventDefault();
            this.rowIndex = jQuery.parseJSON('{ "index": ' + this.$index + ' }');
            $('table tbody').append(this.$rowTemplate(this.rowIndex));
            this.$index += 1;
            this.$submitButton.prop('disabled', false);
        },

        deleteRow: function (ev) {
            ev.preventDefault();
            $('table tr').has('input[type="checkbox"]:checked').remove();
            this.RowsLength = $('table tr').length;
            if (this.RowsLength == 1)
            {
                this.$submitButton.prop('disabled', true);
            }
        },

        quantityValidation: function (ev) {
            this.$rowid = $(ev.target).attr('id');
            this.$quantityValue = $(ev.target).val();
            if (ev.key == 0 && this.$quantityValue == '') {
                return false;
            }

            this.rowIndexValue = jQuery.parseJSON('{ "rowIndex": "' + this.$rowid + '","quantityValue": "' + this.$quantityValue + '"}');
            $(ev.target).parent('td').next('.returnable-quantity').html(this.$returnableRowTemplate(this.rowIndexValue));
            if (ev.which != 9 && ev.which != 8 && ev.which != 0 && (ev.which < 48 || ev.which > 57) && (ev.which < 96 || ev.which > 105)) {
                return false;
            }
        },

        addSerialNumberField: function (ev) {
            ev.preventDefault();
            $('tr').removeClass('row-selected');
            $(ev.target).closest('tr').addClass('row-selected');
            this.quantity = parseInt($('.row-selected .number').val());
            this.value = $('.row-selected .returnQuantities').val().replace(/\,/g, '');
            this.returnableQty = $('.row-selected .returnable-quantity-text').text();
            this.returnableString = this.returnableQty.split(',');
            if (this.returnableString == '') {
                this.returnableQtyLength = this.returnableQty.split(',').length;
            }
            else {
                this.returnableQtyLength = this.returnableQty.split(',').length + 1;
            }

            if (this.value) {
                if (this.returnableQty) {
                    $('.row-selected .returnable-quantity-text').append(', ' + this.value);
                }
                else {
                    $('.row-selected .returnable-quantity-text').append(this.value);
                }

                this.returnableValue = $('.row-selected .returnable-quantity-text').text();
                $('.row-selected .returnable-quantity-hidden').val(this.returnableValue);
                $('.row-selected .returnQuantities').val('');
                if (this.quantity == 1 || this.quantity == this.returnableQtyLength) {
                    $('.row-selected .returnQuantities').hide();
                    $('.row-selected .rma-serialNimber-button').hide();
                }
            }
        },
        /**
         * Checks if the required fields have values for the mandatory elements
         * @param {Object} ev
         */
        checkRequired: function (ev) {
            ev.preventDefault();
            var $mandatoryFields = this.$('input.mandatory,select.mandatory, textarea.mandatory');
            this.error = false;
            _.each($mandatoryFields, function (field) {
                var $field = $(field);
                if ($.trim($field.val()) === '' && $field.closest('fieldset').prop('disabled') !== true && $field.prop('disabled') !== true) {
                    this.error = true;
                    $field.addClass(this.errorClass);
                }
                else {
                    $field.removeClass(this.errorClass);
                }
            }.bind(this));

            this.checkOtherDropdown();
            if (this.error === true) {
                $(this.errorMsg).show();
            } else {
                this.submitForm();
            }
        },

        checkMandatory: function (ev) {
            ev.preventDefault();
            var $mandatoryFields = this.$('input.mandatory,select.mandatory, textarea.mandatory');
            this.error = false;
            _.each($mandatoryFields, function (field) {
                var $field = $(field);
                if ($.trim($field.val()) === '' && $field.closest('fieldset').prop('disabled') !== true && $field.prop('disabled') !== true) {
                    this.error = true;
                    $field.addClass(this.errorClass);
                }
                else {
                    $field.removeClass(this.errorClass);
                }
            }.bind(this));

            this.checkOtherDropdown();
            if (this.error === true) {
                $(this.errorMsg).show();
            } else {
                $(this.errorMsg).hide();
            }
        },

        /**
         * Check if return type is other for any dropdown
         */
        checkOtherDropdown: function () {
            this.$additionalInfoError.hide();
            var $returnReasonFields = this.$('select.returnReason');
            $.each($returnReasonFields, function (i, field) {
                if ($(field).val() === 'other') {
                    this.checkAdditionalInfoField();
                    return false;
                }
            }.bind(this));
        },

        /**
         * Check return quantities or serial numbers
         */
        checkReturnQuantities: function () {
            this.error = false;
            this.$serialInfoError.hide();

            //Checking number of qty input filled
            var filledTextbox = this.$returnQuantities.filter(function () {
                return $.trim($(this).val()) !== '';
            });

            //Checking is any product has serial numbers
            var serialNumbers = this.$selectedCheckbox.filter(function () {
                return $.trim($(this).val()) !== '';
            });

            //If no quantity and no serial numbers selected for any product, do not allow to proceed
            if (!filledTextbox.length && !serialNumbers.length) {
                this.error = true;
                this.$serialInfoError.show();

                //a filled quantity input found, perform some additional checks on it
            } else if (filledTextbox.length) {
                filledTextbox.each(function (index, el) {
                    var $el = $(el);
                    var qty = parseInt($el.closest('tbody tr').find('.qty-returnable').text());
                    var qtyInput = ~~$el.val();
                    if (!_.isNumber(qtyInput) || parseInt(qtyInput) <= 0 || parseInt(qtyInput) > qty || isNaN(qtyInput)) {
                        $el.addClass('error');
                        this.$serialInfoError.show();
                        this.error = true;
                    }
                }.bind(this));
            }
        },

        /**
         * Overriding submitForm and tracking Analytic event
         */
        submitForm() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            ws.views.form.prototype.submitForm.call(this);
        },

        /**
         * Check if additional info field is populated
         */
        checkAdditionalInfoField: function () {
            if (!$.trim(this.$additionalInfoField.val())) {
                this.$additionalInfoField.addClass('error');
                this.$additionalInfoError.show();
                this.error = true;
            }
            else {
                this.$additionalInfoField.removeClass('error');
            }
        }
    });
})(westcon);
